var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQiujieqixuanxing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.47059,
    y: 0.470588,
    width: 12.2353,
    height: 15.0588,
    stroke: "black",
    strokeWidth: 0.941176
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 9,
    height: 3,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 1.7647,
    height: 0.882352,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.56494,
    y: 7,
    width: 1.7647,
    height: 0.882352,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1294,
    y: 7,
    width: 1.7647,
    height: 0.882352,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9.88235,
    width: 1.7647,
    height: 0.882352,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7.56494,
    y: 9.88235,
    width: 1.7647,
    height: 0.882352,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1294,
    y: 9.88235,
    width: 1.7647,
    height: 0.882352,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12.7647,
    width: 1.7647,
    height: 0.882352,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7.56494,
    y: 12.7647,
    width: 1.7647,
    height: 0.882352,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1294,
    y: 12.7647,
    width: 1.7647,
    height: 0.882352,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQiujieqixuanxing);
export default __webpack_public_path__ + "static/media/qiujieqixuanxing.c5ac96c81a3e039fc6de04a0f4fae6ef.svg";
export { ForwardRef as ReactComponent };